export default [
  {
    title: 'Dashboard',
    icon: 'fas fa-home',
    path: '/dashboard',
    view: 'Dashboard',
    dir: 'views/',
    menu: true,
    meta: {
    }
  },
  {
    icon: 'fas fa-handshake',
    path: "/parceiro",
    view: "Parceiro",
    dir: "views/",
    title: "Parceiro",
    menu: true,
    meta: {
    }
  },
  {
    icon: 'fas fa-credit-card',
    path: "/credencial",
    view: "Credencial",
    dir: "views/",
    title: "Credencial",
    menu: true,
    meta: {
    }
  },
  {
    icon: 'fas fa-share-alt',
    path: "/parceiroProduto",
    view: "ParceiroProduto",
    dir: "views/",
    title: "Parceiro - Produto",
    menu: true,
    meta: {
    }
  },
  {
    icon: 'fas fa-filter',
    path: "/tipoCallback",
    view: "TipoCallback",
    dir: "views/",
    title: "Tipo Callback",
    menu: true,
    meta: {
    }
  },
  {
    icon: 'fas fa-satellite-dish',
    path: "/callbackParceiro",
    view: "CallbackParceiro",
    dir: "views/",
    title: "Callback Parceiro",
    menu: true,
    meta: {
    }
  },
  {
    icon: 'fas fa-university',
    path: "/produto",
    view: "Produto",
    dir: "views/",
    title: "Produto",
    menu: true,
    meta: {
      roles: ['Onboarding.Admin'],
    }
  },
  {
    icon: 'fas fa-share-square',
    path: "/reprocessarCallback",
    view: "ReprocessarCallback",
    dir: "views/",
    title: "Callback",
    menu: true,
    meta: {
    }
  },
  {
    icon: 'fas fa-fingerprint',
    path: "/acesso",
    view: "GrupoAcesso",
    dir: "views/",
    title: "Grupo de acesso",
    menu: true,
    meta: {
      roles: ['Onboarding.Admin'],
    }
  },
  {
    icon: 'fas fa-home',
    path: "/recuperarsenha",
    view: "RecuperarSenha",
    dir: "views/",
    title: "Recuperar Senha",
    menu: false,
    meta: {
      anonymousAuth: true
    }
  }

]
